import React, { useEffect, useState } from 'react';
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import TextArea from 'devextreme-react/text-area';
import { makeStyles } from '@material-ui/core/styles';
import { DateBox } from 'devextreme-react';
import { useDispatch, useSelector } from "react-redux";
import { selectWorkshopTypes} from "../../../redux/workshopTypes/selectors";
import { SmsFormTypes } from '../../../Constantes/smsFormTypes';
import { QUERY_GET_ITVS_BY_POSTAL_CODE, QUERY_GET_PROVINCE_BY_POSTALCODE } from '../../../fetch/constantQueries';
import { openModal } from '../../../redux/modal/modalSlice';
import { baseRequest } from '../../../fetch/basicThunk';
import dayjs from 'dayjs';
import SendMailSmsForm from './SendMailSmsForm';

const useStyles = makeStyles({

    label: {
        color: "#eeeeee"
    },
    controlers: {
        width:"100% !important"
    },
    containers: {
        marginBottom:10,
    },
    hideSmsContainer: {
        display:"none"
    },
    input_grid: {
        display: "grid",
        columnGap: 10,
        gridTemplateColumns: "1fr 1fr"
    },
    input :{
        width: "96.5%!important",
        fontSize: "12px",
        paddingLeft: "6px",
        height: "20px",
        outline: "none"
    }
  });

  function InputWrapper(props){
    const {classes, label} = props;
        return(
            <div className="dx-field">
            <label className={classes.label}>{label}</label> 
                <div style={{width:"100%"}} className="dx-field-value">
                    {props.children}
                </div>
        </div>
        )
    }

export default function SmsForm (props) {
    const classes = useStyles();
    const {dataSms,workshopSearch, handleChangeSendSMSForm, setReplacedSms, replacedSms} = props;
    const workshopTypes = useSelector(selectWorkshopTypes).workshopTypes;
    const dispatch = useDispatch()
    const [stations, setStations] = useState([])
    const [initialTextSms, setInitialTextSms] = useState(null)


    useEffect(()=>{
        if((dataSms.contentSms =="" || dataSms.contentSms ==null) || (initialTextSms =="" || initialTextSms ==null)){
            setInitialTextSms(dataSms.contentSms);
        }
        if(dataSms){
            setReplacedSms(replacedContentSms(dataSms.contentSms))
        }
      },[dataSms.contentSms])


      useEffect(()=>{
      },[replacedSms])

    async function setProvince(){
        if(!dataSms?.postalCode || dataSms?.postalCode.length < 5 ){
            handleChangeSendSMSForm("province", null); 
            handleChangeSendSMSForm("stationId", null);
            return
        }
    
        const province = await fetchProvinceFromPostalCode(dataSms?.postalCode);
        
        if(province){
            const provinceHasNewValue = province.name !== dataSms?.province
            if(provinceHasNewValue){
                handleChangeSendSMSForm("stationId", null)
            }
            handleChangeSendSMSForm("province", province.name)
            fetchStations(dataSms?.postalCode)
        } else {
            handleChangeSendSMSForm("stationId", null)
        }
    }

    async function fetchProvinceFromPostalCode(postalCode){
        let province;
        try {
            province = await baseRequest({param: postalCode }, dispatch, QUERY_GET_PROVINCE_BY_POSTALCODE, "GET");
        } catch (error) {
            province = null
            handleChangeSendSMSForm("province", null)
            setStations([])
        }    
        return province
    }

    async function fetchStations(postalCode){

        try {
            const stations = await baseRequest({param: postalCode }, dispatch, QUERY_GET_ITVS_BY_POSTAL_CODE, "GET")
            if(stations){
                setStations(stations)
            }
        } catch (error) {
            dispatch(openModal({type: "error", message: "No se han podido cargar las ITVs"}))
        }
    }

    function replacedContentSms(content,field = "", newValue = null){
        if(dataSms.template){
            if((dataSms.template?.templateCode == "itv_bond" ||  dataSms.template?.templateCode == "telematic_copy" || dataSms.template?.templateCode == "standard_send") && ((!newValue && dataSms?.email != null && dataSms?.email !="") || newValue)){
                content = content.replace('%email%', newValue? newValue : dataSms?.email);
            }
            if(dataSms.template.templateCode =="itv_appointment" ){
                if((!newValue && dataSms?.appointmentDate != null && dataSms?.appointmentDate !="") || (newValue && newValue instanceof Date)){
                    content = content.replace('%date%', newValue ? dayjs(newValue).format("DD/MM/YYYY HH:mm") : dayjs(dataSms?.appointmentDate).format("DD/MM/YYYY HH:mm"));
                }else if(newValue && !(newValue instanceof Date) && (dataSms?.appointmentDate != null && dataSms?.appointmentDate !="")){
                    content = content.replace('%date%', dayjs(dataSms?.appointmentDate).format("DD/MM/YYYY HH:mm"));
                }
                if((!newValue && dataSms?.stationId != null && dataSms?.stationId !="") || newValue){
                    var id = field=="station"? newValue : dataSms?.stationId
                    let station =stations.find((s)=>s.id == id);
                    if(station){
                        content = content.replace('%station%',station.city + ","+ station.address);
                    }
                }
            } else if(dataSms.template.templateCode =="substitution_reference_number" ){
                if((!newValue && dataSms?.date != null && dataSms?.date !="") || (newValue && newValue instanceof Date)){
                    content = content.replace('%date%', newValue ? dayjs(newValue).format("DD/MM/YYYY HH:mm") : dayjs(dataSms?.date).format("DD/MM/YYYY HH:mm"));
                }else if(newValue && !(newValue instanceof Date) && (dataSms?.date != null && dataSms?.date !="")){
                    content = content.replace('%date%', dayjs(dataSms?.date).format("DD/MM/YYYY HH:mm"));
                }
                if(((!newValue && dataSms?.city != null && dataSms?.city !="") || newValue)){
                    content = content.replace('%city%', field=="city"? newValue ? newValue : '%city%' : dataSms?.city ? dataSms?.city : '%city%');
                }
                if(((!newValue && dataSms?.office != null && dataSms?.office !="") || newValue)){
                    content = content.replace('%office%', field=="office"?  newValue ? newValue : '%office%' : dataSms?.office ? dataSms?.office : '%office%');
                }
                if(((!newValue && dataSms?.numberReference != null && dataSms?.numberReference !="") || newValue)){
                    content = content.replace('%number%',  field=="numberReference"?  newValue ? newValue : '%number%' : dataSms?.numberReference? dataSms?.numberReference : '%number%');
                }
            }
        }
        return content;
    }

    function replaceAlreadyChangedContentSms(previousValue, newValue, field = null){
        if(newValue == null || newValue == ""){
            setReplacedSms(replacedContentSms(dataSms?.contentSms, field, newValue))
        }
        else if(previousValue == null || previousValue == ""){
            setReplacedSms(replacedContentSms(dataSms?.contentSms, field, newValue))
        }
        else{
            if(field=="date"){
                setReplacedSms(replacedSms.replace(dayjs(previousValue).format("DD/MM/YYYY HH:mm"),dayjs(newValue).format("DD/MM/YYYY HH:mm")));  
            }else if(field == "station"){
                let station =stations.find((s)=>s.id == previousValue);
                if(station){
                    let prevValue = station.city + ","+ station.address
                    let newStation =stations.find((s)=>s.id == newValue);
                    if(newStation){
                        setReplacedSms(replacedSms.replace(prevValue,newStation.city + ","+ newStation.address));  
                    }
                }
            }else{
                setReplacedSms(replacedContentSms(dataSms?.contentSms, field, newValue))
            }
        }   
    }

    return (<div>   
                <div className={classes.containers}>
                    <div className="dx-field">
                        <label className={classes.label}>Telefone</label> 
                        <div style={{width:"100%"}} className="dx-field-value">
                            <TextBox maxLength={25} valueChangeEvent="keyup" onValueChanged={(e)=>handleChangeSendSMSForm("number",e.value)} value={dataSms.number} className={classes.controlers} height={25}></TextBox>
                        </div>
                    </div>
                </div>
                <div className={classes.containers}>
                    <div className="dx-field">
                        <label className={classes.label}>Template</label> 
                        <div style={{width:"100%"}} className="dx-field-value">
                            <SelectBox value={props.dataSms.template} displayExpr="name" onValueChange={props.handleTemplateChange} placeholder="" dataSource={props.templates} height={25} ></SelectBox>
                        </div>
                    </div>
                </div>
                {
                    ( dataSms.template!=null && dataSms.template.type == "Certificado")  &&
                    <>
                        <div className={classes.containers}>
                            <div className="dx-field">
                                <label className={classes.label}>Matricula</label> 
                                <div style={{width:"100%"}} className="dx-field-value">
                                <TextBox value={dataSms.plate} maxLength={25} onValueChange={(e)=>handleChangeSendSMSForm("plate",e)} valueChangeEvent="keyup"  className={classes.controlers} height={25}></TextBox>
                                </div>
                            </div>
                        </div>
                        <div className={classes.containers}>
                            <div className="dx-field">
                                <label className={classes.label}>Taller</label>
                                <div style={{width:"100%"}} className="dx-field-value">
                                    { workshopSearch == undefined || workshopSearch.length == 0?
                                    <TextBox value={dataSms.workshopId} onValueChange={(e)=>handleChangeSendSMSForm("workshopId",e)} placeholder="Id del taller" maxLength={25} valueChangeEvent="keyup" className={classes.controlers} height={25}></TextBox>
                                    :<SelectBox value={dataSms.workshopId} valueExpr="workshopId" displayExpr="name" onValueChange={(e)=>handleChangeSendSMSForm("workshopId",e)} placeholder="" dataSource={workshopSearch} height={25}></SelectBox> }
                                </div>
                            </div>
                        </div>
                        <div className={classes.containers}>
                            <div className="dx-field">
                                <label className={classes.label}>Tipo</label>
                                <div style={{width:"100%"}} className="dx-field-value"> 
                                    <SelectBox disabled={workshopSearch != undefined || workshopSearch?.length > 0} value={dataSms.workshopType} valueExpr="workshopTypeId" displayExpr="workshopType" onValueChange={(e)=>handleChangeSendSMSForm("workshopType",e)} placeholder="Tipo taller" dataSource={workshopTypes} height={25}></SelectBox>
                                </div>
                            </div>
                        </div>
                        {
                            (dataSms.template!=null && dataSms.template.name == "Cita Taller") &&
                            <div className={classes.containers}>
                                <div className="dx-field">
                                    <label className={classes.label}>Fecha de cita</label> 
                                    <div style={{width:"100%"}} className="dx-field-value">
                                        <DateBox
                                        type="datetime"
                                        className={classes.controlers} 
                                        height={25}
                                        value={dataSms.appointmentDate}
                                        min={new Date().toISOString().slice(0, 10)}
                                        showClearButton={true}
                                        useMaskBehavior={true}
                                        acceptCustomValue={false}
                                        displayFormat="dd/MM/yyyy HH:mm"
                                        applyButtonText="Aceptar"
                                        cancelButtonText="Cancelar"
                                        onValueChanged={(e)=>handleChangeSendSMSForm("appointmentDate",e.value)} />
                                    </div>
                                </div>
                                <SendMailSmsForm classes={classes} onValueChange={handleChangeSendSMSForm} dataSms={dataSms} />
                            </div>
                        }
                    </>
                }
                {( dataSms.template != null && dataSms.template.templateCode =="itv_appointment")  &&
                    <div className={classes.containers}>
                        <div className={classes.input_grid}>
                            <InputWrapper classes={classes} label={"Código postal"}>
                                <TextBox maxLength={5} key={"postalCode"} name="postalCode" value={dataSms?.postalCode} onFocusOut={()=>setProvince()}  onValueChanged={(e) => handleChangeSendSMSForm("postalCode", e.value)} className={classes.controlers} height={25}></TextBox>
                            </InputWrapper>
                            <InputWrapper classes={classes} label={"Provincia"}>
                                <TextBox disabled key={"province"} name="province" value={dataSms?.province} className={classes.controlers} height={25}></TextBox>
                            </InputWrapper>
                        </div>
                        <InputWrapper classes={classes} label={"Estación"}>
                            <SelectBox value={dataSms?.stationId} valueExpr={"id"} 
                                placeholder={""}
                                disabled={!dataSms?.province}
                                searchEnabled
                                onValueChanged={(e) =>{ handleChangeSendSMSForm("stationId",e.value);replaceAlreadyChangedContentSms(dataSms?.stationId, e.value,"station");}} 
                                itemRender={(item)=><div className={classes.custom_item}> <span style={{fontWeight: "bold"}}>{item && `${item.city}`}</span>{item? `, ${item?.address ? item.address : ""} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""}</div>}
                                displayExpr={(item)=> item? `${item?.city}, ${item?.address} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""} 
                                dataSource={stations} height={25} 
                                noDataText={"Nenhuma opção disponível"}>
                            </SelectBox>
                        </InputWrapper>
                        <InputWrapper classes={classes} label={"Fecha y hora"}>
                            <DateBox applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" displayFormat="dd/MM/yyyy HH:mm" value={dataSms?.appointmentDate} onValueChanged={(e) =>{ handleChangeSendSMSForm("appointmentDate", e.value);replaceAlreadyChangedContentSms(dataSms?.date, e.value,"date");}} className={classes.controlers} height={25}></DateBox>
                        </InputWrapper>
                        <SendMailSmsForm classes={classes} onValueChange={handleChangeSendSMSForm} dataSms={dataSms} />
                    </div>
                    }
                    {( dataSms.template != null && dataSms.template.templateCode =="substitution_reference_number")  &&
                        <div className={classes.containers}>

                            <InputWrapper classes={classes} label={"Fecha y hora"}>
                                <DateBox applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" displayFormat="dd/MM/yyyy HH:mm" value={dataSms?.date} onValueChanged={(e) =>{ handleChangeSendSMSForm("date",e.value);replaceAlreadyChangedContentSms(dataSms?.date, e.value,"date");}} className={classes.controlers} height={25}></DateBox>
                            </InputWrapper>
                            <div className={classes.input_grid}>
                                <InputWrapper classes={classes} label={"Localidad"}>
                                    <input key={"city"} name="city" value={dataSms?.city} autocomplete="off" onChange={(e) =>{replaceAlreadyChangedContentSms(dataSms?.city, e.target.value,"city"); handleChangeSendSMSForm("city",e.target.value); }} className={classes.input}></input>
                                </InputWrapper>  
                                <InputWrapper classes={classes} label={"Oficina"}>
                                    <input key={"office"} name="office" value={dataSms?.office} autocomplete="off" onChange={(e) =>{replaceAlreadyChangedContentSms(dataSms?.office, e.target.value,"office"); handleChangeSendSMSForm("office",e.target.value); }} className={classes.input}></input>
                                </InputWrapper>  
                            </div>
                            <InputWrapper classes={classes} label={"Nº de Localizador"}>
                                <input key={"numberReference"} name="numberReference" value={dataSms?.numberReference} autocomplete="off" onChange={(e) =>{replaceAlreadyChangedContentSms(dataSms?.numberReference, e.target.value,"numberReference"); handleChangeSendSMSForm("numberReference",e.target.value); }} className={classes.input}></input>
                            </InputWrapper>  
                        </div>
                    }
                    {( dataSms.template != null && (dataSms.template?.templateCode == "itv_bond" ||  dataSms.template?.templateCode == "telematic_copy" || dataSms.template?.templateCode == "standard_send"))  &&
                        <div className={classes.containers}>
                            <InputWrapper classes={classes} label={"Correo electrónico"}>
                                <input key={"email"} name="email" value={dataSms?.email} autocomplete="off" onChange={(e) =>{replaceAlreadyChangedContentSms(dataSms?.email, e.target.value); handleChangeSendSMSForm("email",e.value); }} className={classes.input}></input>
                            </InputWrapper>   
                        </div>
                    }
                {((dataSms.template == null || dataSms.template.type != "Certificado"))  &&
                <div>
                    <div className="dx-field">
                        <label className={classes.label}>Mensagem</label> 
                        <TextArea maxLength={250} valueChangeEvent="keyup" onValueChanged={(e)=>{handleChangeSendSMSForm("contentSms",e.value)}} value={replacedSms} width={"100%"} height={210}></TextArea>
                    </div>
                </div>
                }
            </div>);
}